import { withNamespaces } from "react-i18next";
import { Card, CardBody, CardTitle } from "reactstrap";
import { CLOSED_ON_TIME_COMPLETION_COLORS } from "src/modules/data-protection/constants";
import Knob from "../../../../components/Knob";

const toNumber = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
};

const ClosedOnTime = ({
    stats,
    t,
}) => {
    if (!stats) {
        return null;
    }

    const closedOnTime = toNumber(stats.closedOnTime ?? stats.amount);
    const closedOverdue = toNumber(stats.closedOverdue);
    const withoutDeadline = toNumber(stats.withoutDeadline);
    const totalClosed = stats.totalClosed == null
        ? closedOnTime + closedOverdue + withoutDeadline
        : toNumber(stats.totalClosed);
    const completionRate = toNumber(stats.onTimeCompletionRate ?? stats.percent);

    const rows = [
        {
            title: "Closed On Time",
            amount: closedOnTime,
            color: CLOSED_ON_TIME_COMPLETION_COLORS.onTime,
        },
        {
            title: "Closed Overdue",
            amount: closedOverdue,
            color: CLOSED_ON_TIME_COMPLETION_COLORS.overdue,
        },
        {
            title: "Without Deadline",
            amount: withoutDeadline,
            color: CLOSED_ON_TIME_COMPLETION_COLORS.withoutDeadline,
        },
    ];

    return (
        <Card className="card_box_Shadow w-100">
            <CardBody>
                <CardTitle className="mb-4">
                    {t("Closed On Time")}
                </CardTitle>

                <div className="d-flex flex-wrap align-items-center">
                    <div className="text-center me-4 mb-3" style={{ minWidth: 160 }}>
                        <Knob
                            value={completionRate}
                            lineCap="round"
                            height={110}
                            width={110}
                            fgColor="#545B9A"
                            thickness={0.12}
                            readOnly={true}
                        />
                        <p className="font-size-14 text-muted mb-0 mt-2">
                            {t("On-time Completion Rate")}
                        </p>
                    </div>

                    <div className="flex-grow-1">
                        {rows.map((row) => (
                            <div
                                key={row.title}
                                className="d-flex align-items-center justify-content-between mb-3"
                            >
                                <div className="d-flex align-items-center">
                                    <i
                                        className="mdi mdi-circle font-size-10 me-2"
                                        style={{ color: row.color }}
                                    />
                                    <span className="font-size-14">{t(row.title)}</span>
                                </div>
                                <h6 className="mb-0">{row.amount}</h6>
                            </div>
                        ))}

                        <div className="d-flex align-items-center justify-content-between border-top pt-3">
                            <span className="font-size-14 text-muted">
                                {t("Total Closed")}
                            </span>
                            <h6 className="mb-0">{totalClosed}</h6>
                        </div>
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(ClosedOnTime);
